import React, { useContext, useEffect, useState } from 'react';
import { Collapse, CollapseProps, Empty, Flex } from 'antd';

import TagPanel from '@totem/components/software/software_report/byTag/tagPanel';
import SoftwareContext from '@totem/components/software/software_report/softwareContext';
import { SoftwarePackage } from '@totem/components/software/software_report/types';
import { emptyId } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull, isNull } from '@totem/utilities/common';

const TagsSection = () => {
  const { userProfile } = useContext(UserProfileContext);
  const [tags, setTags] = useState<string[]>([]);
  const { data, organizationId } = useContext(SoftwareContext);

  const getOrganizationalTags = (pkg: SoftwarePackage) => {
    const orgTags =
      organizationId !== emptyId &&
      isNotNull(data) &&
      isNotNull(pkg) &&
      isNotNull(pkg.organizationTags) &&
      pkg.organizationTags.length > 0 &&
      pkg.organizationTags[0].organizationId === userProfile.organization.id
        ? pkg.organizationTags[0].tags
        : [];

    return orgTags;
  };

  useEffect(() => {
    const taggedSoftware = data.filter(
      (chk) =>
        (isNotNull(chk.tags) && chk.tags.length > 0) ||
        getOrganizationalTags(chk).length > 0,
    );

    const newTags: string[] = [];

    for (let packageIdx = 0; packageIdx < taggedSoftware.length; packageIdx++) {
      const packageTags =
        isNotNull(taggedSoftware[packageIdx].tags) &&
        taggedSoftware[packageIdx].tags.length > 0
          ? taggedSoftware[packageIdx].tags
          : [];
      const orgTags = getOrganizationalTags(taggedSoftware[packageIdx]);
      for (let tagIdx = 0; tagIdx < packageTags.length; tagIdx++) {
        if (newTags.findIndex((chk) => chk === packageTags[tagIdx]) < 0) {
          newTags.push(packageTags[tagIdx]);
        }
      }
      for (let tagIdx = 0; tagIdx < orgTags.length; tagIdx++) {
        if (newTags.findIndex((chk) => chk === orgTags[tagIdx]) < 0) {
          newTags.push(orgTags[tagIdx]);
        }
      }
    }
    setTags(newTags);
  }, [data]);

  const getItems = () => {
    const items: CollapseProps['items'] = tags.map((tag) => {
      const filtered = data.filter((chk) =>
        isNull(chk.tags) && isNull(chk.organizationTags)
          ? false
          : (isNotNull(chk.tags) && chk.tags.includes(tag)) ||
            (isNotNull(chk.organizationTags) &&
              chk.organizationTags.length > 0 &&
              chk.organizationTags[0].tags.includes(tag)),
      );

      return {
        key: tag,
        label: (
          <Flex justify="space-between">
            <div>{tag}</div>
            <div>{filtered.length}</div>
          </Flex>
        ),
        children: <TagPanel tag={tag} packages={filtered} />,
      };
    });

    const filtered = data.filter(
      (chk) => isNull(chk.tags) || chk.tags.length === 0,
    );

    items.push({
      key: 'Untagged',
      label: (
        <Flex justify="space-between">
          <div>Untagged</div>
          <div>{filtered.length}</div>
        </Flex>
      ),
      children: <TagPanel tag={''} packages={filtered} />,
    });

    return items;
  };

  if (isNull(data) || data.length === 0) {
    return <Empty />;
  }

  return (
    <div>
      <Collapse items={getItems()} defaultActiveKey={['1']} />
      <br />
    </div>
  );
};

export default TagsSection;
